import { useQuery } from "@apollo/client/react";
import { buildUserQuery } from "../../logic/user";
import { useEffect, useState } from "react";
import { DynamicObject } from "@superloop-bnsc/lib-logics";
import { userQueryFieldsType } from "@superloop-bnsc/lib-site-configs";

function useAuthCheck (userQueryFields?: userQueryFieldsType[]) {
    const currentUserQuery = useQuery<DynamicObject>(buildUserQuery(userQueryFields));
    const [currentUser, setCurrentUser] = useState<DynamicObject | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        setIsLoading(currentUserQuery?.loading);
    }, [currentUserQuery?.loading]);
    
    useEffect(() => {
        const user = currentUserQuery?.data?.classMethods?.User?.getCurrentUser;

        if (user) {
            setCurrentUser(user);
            setIsLoggedIn(true);
        } else {
            setCurrentUser(null);
            setIsLoggedIn(false);
        }
    }, [currentUserQuery?.data]);

    return {isLoading, isLoggedIn, currentUser, setCurrentUser, refetchUserData: currentUserQuery?.refetch, setIsLoggedIn};
}

export default useAuthCheck;